/**
 * Formats a number to a currency friendly format
 */
export function formatMoneyNoStrip(value) {
  return (value ? value : 0)
    .toFixed(2)
    .toString()
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

/**
 * Formats a number to a currency friendly format and strips the ,00 from it if it is a rounded number
 */
export function formatMoney(value) {
  let formatted = formatMoneyNoStrip(value);
  return formatted.endsWith(",00") ? formatted.substr(0, formatted.length - 3) : formatted;
}

/**
 * Formats a number to a format with
 */
export function formatNumber(value) {
  return (value ? value : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
